<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer [cookieComponent]="cookieContext"></app-footer>
<app-cookie-dialog #cookieContext></app-cookie-dialog>
